import AbstractPolicy from "@/policies/Proposal/Product/ProductPolicy/AbstractPolicy";

export default class TravelnetImporterNotifyPolicy extends AbstractPolicy {

    static updatePurchasePrices() {
        return false;
    }

    static moveOptional() {
        return false;
    }

    static delete(user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        if (this._isProposalLocked(product)) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

}
